export const programs = [
  {
    id: 1,
    name: "Full Stack Development",
    description:
      "Master both frontend and backend technologies to build complete web applications. Learn HTML, CSS, JavaScript, React, Node.js, and databases.",
    icon: "https://res.cloudinary.com/dyvxdlyrr/image/upload/v1774510623/fullstack_cly1cv.jpg",
    color: "#3498db",
    features: [
      "12-month access",
      "Real-world projects",
      "Mentor support",
      "Placement assistance",
    ],
    popular: true,
  },
  {
    id: 2,
    name: "Frontend Development",
    description:
      "Learn HTML, CSS, JavaScript and modern frameworks like React and Vue to create stunning user interfaces.",
    icon: "https://res.cloudinary.com/dyvxdlyrr/image/upload/v1763564303/Front_end_r1jgky.png",
    color: "#9b59b6",
    features: [
      "8-month access",
      "Portfolio projects",
      "Code reviews",
      "UI/UX principles",
    ],
    popular: false,
  },
  {
    id: 3,
    name: "Backend Development",
    description:
      "Focus on server-side programming, databases, APIs and system architecture with Node.js, Python, and cloud platforms.",
    icon: "https://res.cloudinary.com/dyvxdlyrr/image/upload/v1774511037/Screenshot_2026-03-26_131330_wqykyg.png",
    color: "#e74c3c",
    features: [
      "10-month access",
      "API development",
      "Database design",
      "Deployment strategies",
    ],
    popular: false,
  },
  {
    id: 4,
    name: "AI/ML",
    description:
      "Dive into artificial intelligence, machine learning algorithms and data modeling with Python, TensorFlow, and PyTorch.",
    icon: "https://res.cloudinary.com/dyvxdlyrr/image/upload/v1763564307/AI_hc83nu.png",
    color: "#2ecc71",

    features: ["ML projects", "Model deployment", "Industry datasets"],
    popular: true,
    tag: "ai-ml",
  },
  {
    id: 5,
    name: "Data Science",
    description:
      "Learn to extract insights from data using statistical analysis, visualization, and machine learning techniques.",
    icon: "https://res.cloudinary.com/dyvxdlyrr/image/upload/v1774511462/representation-user-experience-interface-design_jq09nb.png",
    color: "#f39c12",
    features: ["Python", "Data visualization", "Statistical modeling"],
    popular: false,
    tag: "data-science",
  },
  {
    id: 6,
    name: "Cyber Security",
    description:
      "Protect systems and networks from digital attacks. Learn ethical hacking, network security, and risk management.",
    icon: "https://res.cloudinary.com/dyvxdlyrr/image/upload/v1763564313/Cyber_Security_ffox1x.png",
    color: "#34495e",

    features: ["Hands-on labs", "Security tools", "Certification prep"],
    popular: true,
    tag: "cyber-security",
  },
  {
    id: 7,
    name: "Python Programming",
    description:
      "Master Python from basics to advanced concepts and real-world applications in web development, data analysis, and automation.",
    icon: "https://res.cloudinary.com/dyvxdlyrr/image/upload/v1763564322/Python_aibeiw.png",
    color: "#1abc9c",

    features: ["Practical exercises", "Project building", "Best practices"],
    popular: false,
    tag: "python-programming",
  },
  {
    id: 8,
    name: "Google Sheets",
    description:
      "Google Sheets courses help you quickly learn how to organize, analyze, and manage data using formulas, charts, and smart tools..",
    icon: "https://res.cloudinary.com/dyvxdlyrr/image/upload/v1763564380/Google_Sheets_xlga1g.png",
    color: "#27ae60",
    features: ["Database design", "CRUD operations", "Aggregation framework"],
    popular: false,
    tag: "google-sheets",
  },
  // {
  //   id: 9,
  //   name: "AR/VR Development",
  //   description:
  //     "Create immersive augmented and virtual reality experiences using Unity, 3D modeling, and spatial computing.",
  //   icon: "👓",
  //   color: "#8e44ad",
  //   features: [
  //     "10-month access",
  //     "Unity development",
  //     "3D modeling basics",
  //     "XR interactions",
  //   ],
  //   popular: false,
  // },

  {
    id: 11,
    name: "Block Chain",
    description:
      " Blockchain is a secure, decentralized technology that records data in tamper-proof blocks, enabling transparent and trusted digital transactions.",
    icon: "https://res.cloudinary.com/dyvxdlyrr/image/upload/v1763564327/Block_Chaik_aducvt.png",
    color: "#d35400",
    features: [
      "Hands-on practice",
      "Workflow automation",
      "Team collaboration",
    ],
    popular: false,
    tag: "block-chain",
  },
  // {
  //   id: 12,
  //   name: "C Programming",
  //   description:
  //     "C programming is a powerful and efficient language used to build system software, operating systems, and high-performance applications.",
  //   icon: "https://res.cloudinary.com/dyvxdlyrr/image/upload/v1763565230/C_language_a7vg7u.png",
  //   color: "#d35400",
  //   features: [
  //     "Hands-on practice",
  //     "Workflow automation",
  //     "Team collaboration",
  //   ],
  //   popular: false,
  //   tag: "c-programming",
  // },

  {
    id: 14,
    name: "Digital Marketing",
    description:
      "Digital marketing is the online strategy of promoting products or services using channels like social media, SEO, ads, and email to reach and engage customers effectively.",
    icon: "https://res.cloudinary.com/dyvxdlyrr/image/upload/v1763565464/Digital_Marketing_uza7zk.png",
    color: "#d35400",
    features: [
      "Hands-on practice",
      "Workflow automation",
      "Team collaboration",
    ],
    popular: false,
    tag: "digital-marketing",
  },
  {
    id: 15,
    name: "IoT",
    description:
      "IoT (Internet of Things) connects everyday devices to the internet so they can collect, share, and act on data intelligently.",
    icon: "https://res.cloudinary.com/dyvxdlyrr/image/upload/v1763564343/IOT_fkni9y.png",
    color: "#d35400",
    features: [
      "Hands-on practice",
      "Workflow automation",
      "Team collaboration",
    ],
    popular: false,
    tag: "iot",
  },
  // {
  //   id: 16,
  //   name: "DevOps Basics",
  //   description:
  //     "DevOps is a collaborative approach that unifies development and operations to deliver software faster, more reliably, and with continuous improvement.",
  //   icon: "https://res.cloudinary.com/dyvxdlyrr/image/upload/v1763564352/Devops_iuddzz.png",
  //   color: "#d35400",
  //   features: [
  //     "Hands-on practice",
  //     "Workflow automation",
  //     "Team collaboration",
  //   ],
  //   popular: false,
  //   tag: "devops-basics",
  // },
];
